import Vue from 'vue';
import vuetify from './plugins/vuetify';
import App from './App';

(function () {
  if ( typeof NodeList.prototype.forEach === "function" ) return false;
  NodeList.prototype.forEach = Array.prototype.forEach;
})();

Vue.config.productionTip = false;

new Vue({
  vuetify,
  render: h => h(App),
}).$mount('.app');
